export const thuongHieu = {
  sections: {
    list: { title: '品牌' },
    detail: { title: '品牌' },
  },
  titles: { add: '新增品牌', edit: '编辑品牌', create: '创建品牌' },
  columns: {
    code: '编码',
    summary: '品牌名称',
    note: '备注',
    status: '状态',
    logo: 'Logo',
    soHangHoa: '商品数',
    nguoiTao: '创建人',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按编码或名称搜索...',
    textDetailTitle: '详细筛选',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '排序方向',
  },
  filters: {
    hintSection: '提示',
    hintBody: '商品使用的品牌目录。',
    statusAll: '全部',
    brandTreeSection: '品牌',
    treeAll: '全部品牌',
    treeSearch: '搜索品牌',
  },
  sort: {
    ngayTao: '创建时间',
    maThuongHieu: '品牌编码',
    tenThuongHieu: '品牌名称',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  actions: {
    pause: '停用',
    activate: '启用',
  },
  messages: {
    loadError: '无法加载品牌列表。',
    deleteSuccess: '已删除品牌。',
    noData: '暂无品牌。',
    listSummary: '共 {count} 条',
    saveSuccess: '已保存品牌。',
    statusChanged: '状态已更新。',
    createSuccess: '已创建品牌',
    selectedCount: '已选 {count} 项',
    deleteSelected: '删除所选 ({count})',
    bulkDeleteConfirm: '确定删除所选的 {count} 个品牌？',
    bulkDeleteSuccess: '已删除 {count} 个品牌',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 项失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '请先选择要删除的品牌',
    hhCount: '{count} 件',
  },
  form: {
    tenThuongHieu: '品牌名称',
    maThuongHieu: '品牌编码',
    ghiChu: '备注',
    logoHint: '最大 5MB。格式 png/jpg/jpeg。也可拖放图片到框内。',
    logoChoose: '选择 Logo',
    logoPaste: '粘贴 Logo',
    logoPasteHint: '可拖放图片、从剪贴板粘贴或使用 http(s) 链接。',
    logoDragDrop: '将图片拖放到此处',
  },
  validation: {
    tenRequired: '请输入品牌名称。',
    maSaiDinhDang: '编码格式须为 {prefix}xxx（例如 {prefix}001）。',
  },
  import: {
    description:
      'Excel 文件包含 3 列：品牌编码（可选，格式为 TH{项目编码}-xxx，全系统不可重复）、品牌名称（必填）、备注（可选）。编码留空将自动生成。',
    success: '已从 Excel 导入品牌。',
    failed: '从 Excel 导入品牌失败。',
  },
  placeholders: {
    formTitle: '品牌',
    formBody: '',
    tenThuongHieu: '请输入品牌名称',
    maThuongHieu: '留空则自动生成 TH{项目编码}-001。编码在全系统内不可重复。',
    maThuongHieuTheoDuAn: '留空则自动生成，或输入 {prefix}001',
  },
}
